// import React from "react";
// import Modal from "../../modal";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Swal from "sweetalert2";
// import axios from "axios";
// import cookie from "react-cookies";
// import { UNIFIED_BASE_URL, WEB_BASE_URL } from "../../webbase";
// class ViewDealer extends React.Component {
//   constructor() {
//     super();
//     this.state = {
//       userEmail: cookie.load("useAdmin"),
//       token: cookie.load("tokenAdmin"),
//       users: [],
//       searchTerm: '', // Add search term to state
//       currentPage: 1,
//       itemsPerPage: 15,
//     };
//     console.log(this.state.token);
//     this.onInviteUser = this.onInviteUser.bind(this);
//     this.getUsers = this.getUsers.bind(this);
//     this.onChangeRole = this.onChangeRole.bind(this);
//     this.reInvite = this.reInvite.bind(this);
//     this.handleSearch = this.handleSearch.bind(this);
//     this.handlePageChange = this.handlePageChange.bind(this);
//   }

//   onInviteUser(event) {
//     event.preventDefault();
//     if (this.state.formEmail !== "" && this.state.formRole !== "") {
//       toast.success("User Role Edited!!!");
//     } else {
//       toast.error("User Role Edit failed!!!");
//     }
//   }

//   reInvite(email) {
//     console.log(email);
//     const id = toast.loading("Please wait...");
//     axios
//       .post(
//         UNIFIED_BASE_URL + "/manage/re-inviteDealer?emailAddress=" + email,
//         {},
//         {
//           headers: {
//             authorization: this.state.token,
//             emailAddress: email,
//           },
//         }
//       )
//       .then((res) => {
//         console.log(res);
//         if (res.data.status === "2000") {
//           toast.update(id, {
//             render: res.data.description,
//             type: "success",
//             isLoading: false,
//           });
//         } else {
//           toast.update(id, {
//             render:  res.data.description,
//             type: "error",
//             isLoading: false,
//           });
//         }

//         this.getUsers();
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }
//   toggleUser(email) {
//     Swal.fire({
//       title: 'Are you sure?',
//       text: "You are about to you are about to activate/deactivate a user on enterprise!",
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Yes, toggle it!'
//     }).then((result) => {
//       if (result.isConfirmed) {
//         const id = toast.loading("Please wait...");
//         axios
//           .get(
//             UNIFIED_BASE_URL + "/manage/activate-dealer?dealerId=" + email,
//             {
//               headers: {
//                 authorization: this.state.token,
//                 dealerId: email,
//               },
//             }
//           )
//           .then((res) => {
//             console.log(res);
//             if (res.data.status === "2000") {
//               toast.update(id, {
//                 render: res.data.description,
//                 type: "success",
//                 isLoading: false,
//               });
//               window.location.reload();
//             } else {
//               toast.update(id, {
//                 render: res.data.description,
//                 type: "error",
//                 isLoading: false,
//               });
//             }

//             this.getUsers();
//           })
//           .catch((err) => {
//             console.log(err);
//           });
//       }
//     });
//   }

//   toggleUser2(email) {
//     Swal.fire({
//       title: 'Are you sure?',
//       text: "You are about to you are about to activate/deactivate a user dashboard!",
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Yes, toggle it!'
//     }).then((result) => {
//       if (result.isConfirmed) {
//         // Set loading state
//         this.setState(prevState => ({
//           loadingDealers: {
//             ...prevState.loadingDealers,
//             [email]: true
//           }
//         }));
//
//         const id = toast.loading("Please wait...");
//         axios
//           .get(
//             UNIFIED_BASE_URL + "/toogle-dealer?emailAddress=" + email,
//             {
//               headers: {
//                 authorization: this.state.token,
//                 dealerId: email,
//               },
//             }
//           )
//           .then((res) => {
//             console.log(res);
//             if (res.data.status === "2000") {
//               toast.update(id, {
//                 render: res.data.description,
//                 type: "success",
//                 isLoading: false,
//               });
//               window.location.reload();
//             } else {
//               toast.update(id, {
//                 render: res.data.description,
//                 type: "error",
//                 isLoading: false,
//               });
//             }
//           })
//           .catch((err) => {
//             console.log(err);
//             toast.dismiss(id);
//             toast.error("An error occurred");
//           })
//           .finally(() => {
//              // Clear loading state
//              this.setState(prevState => {
//               const newLoadingDealers = { ...prevState.loadingDealers };
//               delete newLoadingDealers[email];
//               return { loadingDealers: newLoadingDealers };
//             });
//             this.getUsers();
//           });
//       }
//     });
//   }

//   //get all users
//   getUsers() {
//     axios
//       .get(UNIFIED_BASE_URL + "/manage/get-dealer", {
//         headers: {
//           authorization: this.state.token,
//         },
//       })
//       .then((res) => {
//         console.log(res.data);
//         if (res.data.status === "2000") {
//           this.setState({
//             users: res.data.data,
//           });
//         } else {
//           toast.error(res.data.description);
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }

//   //set state for formRole
//   onChangeRole(event) { }

//   componentDidMount() {
//     this.getUsers();
//   }

//   handleSearch(event) {
//     this.setState({ 
//       searchTerm: event.target.value,
//       currentPage: 1 // Reset to first page when searching
//     });
//   }

//   handlePageChange(pageNumber) {
//     this.setState({ currentPage: pageNumber });
//   }

//   render() {
//     // Filter users based on search term
//     const filteredUsers = this.state.users.filter(user => 
//       user.businessName?.toLowerCase().includes(this.state.searchTerm.toLowerCase())
//     );

//     // Pagination logic
//     const { currentPage, itemsPerPage } = this.state;
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentItems = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);
//     const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

//     return (
//       <main className="page-content">
//         <ToastContainer
//           position="top-center"
//           autoClose={3000}
//           hideProgressBar={false}
//           newestOnTop={false}
//           closeOnClick
//           rtl={false}
//           pauseOnFocusLoss
//           draggable
//           pauseOnHover
//         />
//         <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
//           <div className="ps-3">
//             <nav aria-label="breadcrumb">
//               <ol className="breadcrumb mb-0 p-0">
//                 <li className="breadcrumb-item">
//                   <a href="javascript:;">
//                     <i className="bx bx-home-alt"></i>
//                   </a>
//                 </li>
//                 <li className="breadcrumb-item active" aria-current="page">
//                   All Dealers
//                 </li>
//               </ol>
//             </nav>
//           </div>
//           <div className="ms-auto"></div>
//         </div>
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center">
//               <h5 className="mb-0">All Users Under You</h5>
//               <form className="ms-auto position-relative">
//                 <div className="position-absolute top-50 translate-middle-y search-icon px-3">
//                   <i className="bi bi-search"></i>
//                 </div>
//                 <input
//                   className="form-control ps-5"
//                   type="text"
//                   placeholder="search"
//                   value={this.state.searchTerm}
//                   onChange={this.handleSearch}
//                 />
//               </form>
//             </div>
//             <div className="table-responsive mt-3">
//               <table className="table align-middle">
//                 <thead className="table-secondary">
//                   <tr>
//                     <th>#</th>
//                     <th>Name</th>
//                     <th>Email</th>
//                     <th>States</th>
//                     <th>Role</th>
//                     <th> Dashboard</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentItems.map((user, index) => (
//                     <tr key={index}>
//                       <td>{indexOfFirstItem + index + 1}</td>
//                       <td>
//                         <div className="d-flex align-items-center gap-3 cursor-pointer">

//                           <div className="">
//                             <p className="mb-0"></p>
//                             {user.businessName}
//                           </div>
//                         </div>
//                       </td>
//                       <td>{user?.businessEmail}</td>
//                       <td>{user?.states}</td>
//                       <td>Dealer</td>
//                       <td>
//                         <div className="table-actions d-flex align-items-center gap-3 ">
//                         <div></div>
//                         <a
//                             href="javascript:;"
//                             className= {user?.status === "active"? `text-success `:`text-danger`}
//                             data-bs-toggle="tooltip"
//                             data-bs-placement="bottom"
//                              title= {user?.status === "active"? `Deactivate user Dashboard `:`Activate user Dashboard`}
//                              onClick={(e) => this.toggleUser2(user?.businessEmail)}
//                           >
//                               <i className="bi bi-toggle-on"></i>
//                           </a>
//                         </div>
//                       </td>
//                       <td>
//                         <div className="table-actions d-flex align-items-center gap-3 fs-6">
//                           <a
//                             href="javascript:void(0);"
//                             class="text-success mx-2"
//                             title="ReInvite Dealer"
//                             data-bs-original-title="Reprint"
//                             aria-label="Reprint"
//                             onClick={(e) => this.reInvite(user?.businessEmail)}
//                           >
//                             <i class="bi  bi-arrow-repeat"></i>
//                           </a>
//                           {/* <a
//                             href="javascript:void(0);"
//                             class="text-success mx-2"
//                             title="Get Reports"
//                             data-bs-original-title="Reports"
//                             aria-label="Report"
//                             onClick={(e) => { }}
//                           >
//                             <i class="bi bi-bar-chart-fill"></i>
//                           </a> */}
//                           {/* <a
//                             href="javascript:;"
//                             className="text-danger"
//                             data-bs-toggle="tooltip"
//                             data-bs-placement="bottom"
//                             title="Disable"
//                           >
//                             <i className="bi bi-x-circle-fill"></i>
//                           </a> */}
//                           <a
//                             href="javascript:;"
//                             className= {user?.enterprise? `text-success`:`text-danger`}
//                             data-bs-toggle="tooltip"
//                             data-bs-placement="bottom"
//                              title={user?.enterprise? `Deactivate Enterprise Merchant`:`Activate Enterprise Merchant`}
//                              onClick={(e) => this.toggleUser(user?.dealerId)}
//                           >
//                               <i className="bi bi-toggle-on"></i>
//                           </a>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>

//               {/* Pagination Controls */}
//               {totalPages > 1 && (
//                 <nav aria-label="Page navigation">
//                   <ul className="pagination justify-content-end mt-3">
//                     <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                       <a 
//                         className="page-link" 
//                         href="javascript:;" 
//                         onClick={() => this.handlePageChange(currentPage - 1)}
//                         aria-disabled={currentPage === 1}
//                       >
//                         Previous
//                       </a>
//                     </li>

//                     {[...Array(totalPages)].map((_, index) => {
//                       const pageNumber = index + 1;
//                       return (
//                         <li 
//                           key={pageNumber} 
//                           className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}
//                         >
//                           <a 
//                             className="page-link" 
//                             href="javascript:;" 
//                             onClick={() => this.handlePageChange(pageNumber)}
//                           >
//                             {pageNumber}
//                           </a>
//                         </li>
//                       );
//                     })}

//                     <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
//                       <a 
//                         className="page-link" 
//                         href="javascript:;" 
//                         onClick={() => this.handlePageChange(currentPage + 1)}
//                         aria-disabled={currentPage === totalPages}
//                       >
//                         Next
//                       </a>
//                     </li>
//                   </ul>
//                 </nav>
//               )}

//               <Modal
//                 title="Edit User"
//                 id="editModal"
//                 buttonText="Effect Role Change"
//                 onSubmit={this.onInviteUser}
//                 onChangeEmail={this.onChangeEmail}
//                 onChangeRole={this.onChangeRole}
//                 formEmail={"Thomas@gmail.com"}
//                 formRole={this.state.formRole}
//               ></Modal>
//             </div>
//           </div>
//         </div>
//       </main>
//     );
//   }
// }

// export default ViewDealer;


import React from "react";
import Modal from "../../modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import axios from "axios";
import cookie from "react-cookies";
import { UNIFIED_BASE_URL, WEB_BASE_URL } from "../../webbase";

class ViewDealer extends React.Component {
  constructor() {
    super();
    this.state = {
      userEmail: cookie.load("useAdmin"),
      token: cookie.load("tokenAdmin"),
      users: [],
      searchTerm: '',
      currentPage: 1,
      itemsPerPage: 15,
      // paystack modal
      showPaystackModal: false,
      paystackKey: "",
      transactionPin: "",
      loadingDealers: {}, // Track loading state for each dealer
    };

    this.onInviteUser = this.onInviteUser.bind(this);
    this.getUsers = this.getUsers.bind(this);
    this.onChangeRole = this.onChangeRole.bind(this);
    this.reInvite = this.reInvite.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleUpdatePaystack = this.handleUpdatePaystack.bind(this);
    this.toggleUser2 = this.toggleUser2.bind(this);
  }

  onInviteUser(event) {
    event.preventDefault();
    if (this.state.formEmail !== "" && this.state.formRole !== "") {
      toast.success("User Role Edited!!!");
    } else {
      toast.error("User Role Edit failed!!!");
    }
  }

  reInvite(email) {
    const id = toast.loading("Please wait...");
    axios
      .post(
        UNIFIED_BASE_URL + "/manage/re-inviteDealer?emailAddress=" + email,
        {},
        {
          headers: {
            authorization: this.state.token,
            emailAddress: email,
          },
        }
      )
      .then((res) => {
        if (res.data.status === "2000") {
          toast.update(id, { render: res.data.description, type: "success", isLoading: false });
        } else {
          toast.update(id, { render: res.data.description, type: "error", isLoading: false });
        }
        this.getUsers();
      })
      .catch((err) => console.log(err));
  }

  toggleUser2(email) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You are about to activate/deactivate a user dashboard!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, toggle it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState(prevState => ({
          loadingDealers: { ...prevState.loadingDealers, [email]: true }
        }));

        const id = toast.loading("Please wait...");
        axios
          // .get(
          //   UNIFIED_BASE_URL + "/manage/toggle-dealer?emailAddress=" + email,
          //   {
          //     dealerId: email
          //   },
          //   {
          //     headers: {
          //       authorization: this.state.token
          //     },
          //   }
          // )

          .get(UNIFIED_BASE_URL + "/manage/toggle-dealer?emailAddress=" + email, {
        headers: { authorization: this.state.token },
      })


          


          .then((res) => {
            if (res.data.status === "2000") {
              toast.update(id, {
                render: res.data.description,
                type: "success",
                isLoading: false,
              });
              this.getUsers();
            } else {
              toast.update(id, {
                render: res.data.description,
                type: "error",
                isLoading: false,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            toast.dismiss(id);
            toast.error("An error occurred");
          })
          .finally(() => {
            this.setState(prevState => {
              const newLoadingDealers = { ...prevState.loadingDealers };
              delete newLoadingDealers[email];
              return { loadingDealers: newLoadingDealers };
            });
          });
      }
    });
  }

  // handleUpdatePaystack(e) {
  //   e.preventDefault();
  //   const { paystackKey, transactionPin, token } = this.state;

  //   if (!paystackKey || !transactionPin) {
  //     toast.error("Both Paystack Key and Transaction Pin are required!");
  //     return;
  //   }

  //   const id = toast.loading("Updating credentials...");

  //   axios.post(
  //     UNIFIED_BASE_URL + "/onboarding/update-dealer-credentials",
  //     { paystackKey, transactionPin },
  //     {
  //       headers: { authorization: token }
  //     }
  //   )
  //     .then((res) => {
  //       toast.update(id, {
  //         render: "Paystack credentials updated successfully!",
  //         type: "success",
  //         isLoading: false,
  //         autoClose: 3000
  //       });
  //       this.setState({ showPaystackModal: false, paystackKey: "", transactionPin: "" });
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //       toast.update(id, {
  //         render: "Failed to update credentials",
  //         type: "error",
  //         isLoading: false,
  //         autoClose: 3000
  //       });
  //     });
  // }

  //get all users
  // handleUpdatePaystack(e) {
  //   e.preventDefault();
  //   const { paystackKey, transactionPin, token } = this.state;

  //   if (!paystackKey || !transactionPin) {
  //     toast.error("Both Paystack Key and Transaction Pin are required!");
  //     return;
  //   }

  //   const id = toast.loading("Updating credentials...");

  //   // Close modal immediately
  //   this.setState({ showPaystackModal: false, paystackKey: "", transactionPin: "" });

  //   axios.post(
  //     UNIFIED_BASE_URL + "/onboarding/update-dealer-credentials",
  //     { paystackKey, transactionPin },
  //     { headers: { authorization: token } }
  //   )
  //     .then((res) => {
  //       if (res.data.status === "2000") {
  //         toast.update(id, {
  //           render: res.data.description || "Paystack credentials updated successfully!",
  //           type: "success",
  //           isLoading: false,
  //           autoClose: 3000
  //         });
  //       } else {
  //         toast.update(id, {
  //           render: res.data.description || "Failed to update credentials",
  //           type: "error",
  //           isLoading: false,
  //           autoClose: 3000
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //       toast.update(id, {
  //         render: "Something went wrong, please try again.",
  //         type: "error",
  //         isLoading: false,
  //         autoClose: 3000
  //       });
  //     });
  // }


  handleUpdatePaystack(e) {
    e.preventDefault();
    const { paystackKey, transactionPin, token, selectedDealerId } = this.state;

    if (!paystackKey || !transactionPin) {
      toast.error("Both Paystack Key and Transaction Pin are required!");
      return;
    }

    if (!selectedDealerId) {
      toast.error("Dealer ID is missing. Please select a dealer again.");
      return;
    }

    const id = toast.loading("Updating credentials...");

    // Close modal immediately for UX
    this.setState({ showPaystackModal: false, paystackKey: "", transactionPin: "" });

    axios
      .post(
        UNIFIED_BASE_URL + "/onboarding/update-dealer-credentials",
        {
          dealerId: selectedDealerId,
          paystackKey,
          transactionPin,
        },
        {
          headers: { authorization: token },
        }
      )
      .then((res) => {
        if (res.data.status === "2000") {
          toast.update(id, {
            render: res.data.description || "Paystack credentials updated successfully!",
            type: "success",
            isLoading: false,
            autoClose: 3000,
          });
        } else {
          toast.update(id, {
            render: res.data.description || "Failed to update credentials",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        }
      })
      .catch((err) => {
        console.error(err);
        toast.update(id, {
          render: "Something went wrong, please try again.",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      });
  }



  getUsers() {
    axios
      .get(UNIFIED_BASE_URL + "/manage/get-dealer", {
        headers: { authorization: this.state.token },
      })
      .then((res) => {
        if (res.data.status === "2000") {
          this.setState({ users: res.data.data });
        } else {
          toast.error(res.data.description);
        }
      })
      .catch((err) => console.log(err));
  }

  //set state for formRole
  onChangeRole(event) { }

  componentDidMount() {
    this.getUsers();
  }

  handleSearch(event) {
    this.setState({ searchTerm: event.target.value, currentPage: 1 });
  }

  handlePageChange(pageNumber) {
    this.setState({ currentPage: pageNumber });
  }

  render() {
    const filteredUsers = this.state.users.filter(user =>
      user.businessName?.toLowerCase().includes(this.state.searchTerm.toLowerCase())
    );

    const { currentPage, itemsPerPage } = this.state;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);

    return (
      <main className="page-content">
        <ToastContainer position="top-center" autoClose={3000} />

        <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
          <div className="ps-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0 p-0">
                <li className="breadcrumb-item">
                  <a href="javascript:;">
                    <i className="bx bx-home-alt"></i>
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  All Dealers
                </li>
              </ol>
            </nav>
          </div>
          <div className="ms-auto"></div>
        </div>

        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center">
              <h5 className="mb-0">All Users Under You</h5>
              <form className="ms-auto position-relative">
                <div className="position-absolute top-50 translate-middle-y search-icon px-3">
                  <i className="bi bi-search"></i>
                </div>
                <input
                  className="form-control ps-5"
                  type="text"
                  placeholder="search"
                  value={this.state.searchTerm}
                  onChange={this.handleSearch}
                />
              </form>
            </div>

            <div className="table-responsive mt-3">
              <table className="table align-middle">
                <thead className="table-secondary">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>States</th>
                    <th>Role</th>
                    <th>Dashboard</th>
                    <th>Actions</th>
                    <th>Update Paystack Key</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((user, index) => (
                    <tr key={index}>
                      <td>{indexOfFirstItem + index + 1}</td>
                      <td>{user.businessName}</td>
                      <td>{user?.businessEmail}</td>
                      <td>{user?.states}</td>
                      <td>Dealer</td>
                      <td>
                        {this.state.loadingDealers[user?.businessEmail] ? (
                          <div className="spinner-border spinner-border-sm text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <a
                            href="javascript:;"
                            className={user?.status === "active" ? `text-success` : `text-danger`}
                            title={user?.status === "active" ? `Deactivate user Dashboard` : `Activate user Dashboard`}
                            onClick={(e) => this.toggleUser2(user?.businessEmail)}
                          >
                            <i className={`bi ${user?.status === "active" ? "bi-toggle-on" : "bi-toggle-off"}`}></i>
                          </a>
                        )}
                      </td>
                      <td>
                        <a
                          href="javascript:void(0);"
                          className="text-success mx-2"
                          title="ReInvite Dealer"
                          onClick={(e) => this.reInvite(user?.businessEmail)}
                        >
                          <i className="bi  bi-arrow-repeat"></i>
                        </a>
                      </td>
                      <td>

                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() =>
                            this.setState({
                              showPaystackModal: true,
                              selectedDealerId: user?.dealerId,
                            })
                          }
                        >
                          Update Key
                        </button>

                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {totalPages > 1 && (
                <nav aria-label="Page navigation">
                  <ul className="pagination justify-content-end mt-3">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <a
                        className="page-link"
                        href="javascript:;"
                        onClick={() => this.handlePageChange(currentPage - 1)}
                      >
                        Previous
                      </a>
                    </li>
                    {[...Array(totalPages)].map((_, index) => {
                      const pageNumber = index + 1;
                      return (
                        <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                          <a
                            className="page-link"
                            href="javascript:;"
                            onClick={() => this.handlePageChange(pageNumber)}
                          >
                            {pageNumber}
                          </a>
                        </li>
                      );
                    })}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <a
                        className="page-link"
                        href="javascript:;"
                        onClick={() => this.handlePageChange(currentPage + 1)}
                      >
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              )}

              {/* Paystack Modal with Overlay */}
              {this.state.showPaystackModal && (
                <>
                  {/* Overlay */}
                  <div
                    className="modal-backdrop fade show"
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0,0,0,0.5)",
                      zIndex: 1040,
                    }}
                    onClick={() => this.setState({ showPaystackModal: false })}
                  ></div>

                  {/* Modal */}
                  <div
                    className="modal fade show"
                    style={{ display: "block", zIndex: 1050 }}
                  >
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Update Paystack Credentials</h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => this.setState({ showPaystackModal: false })}
                          ></button>
                        </div>
                        <form onSubmit={(e) => this.handleUpdatePaystack(e)}>
                          <div className="modal-body">
                            <div className="mb-3">
                              <label className="form-label">Paystack Key</label>
                              <input
                                type="text"
                                className="form-control"
                                value={this.state.paystackKey}
                                onChange={(e) => this.setState({ paystackKey: e.target.value })}
                              />
                            </div>
                            <div className="mb-3">
                              <label className="form-label">Transaction Pin</label>
                              <input
                                type="password"
                                className="form-control"
                                value={this.state.transactionPin}
                                onChange={(e) => this.setState({ transactionPin: e.target.value })}
                              />
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() => this.setState({ showPaystackModal: false })}
                            >
                              Close
                            </button>
                            <button type="submit" className="btn btn-primary">
                              Save
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </>
              )}

            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default ViewDealer;
